<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="small-panel" @click.stop>
                <div class="dialog-title">
                    <span>{{ dialogData.payload.deviceId }}</span><br>
                    <span v-t="{
                        path: 'message.dialog_confirm_device_management',
                        args: { actionName: $t(`message.action_device_management_${dialogData.action}`).replace(/[\[\]\s]/g, '') }
                    }"></span>
                </div>
                <!-- <hr class="dialog-hr"> -->
                <div v-if="dialogData.action === 'delete'">
                    <div class="confirm-body">
                        <span v-t="'message.caution_device_management_force_logout'">
                        </span>
                    </div>
                </div>
                <!-- <hr class="dialog-hr"> -->
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" type="button" @click="$emit('cancel')"
                        v-t="'message.button_cancel'"></el-button>
                    <el-button class="dialog-ok-button" type="button"
                        @click="$emit(dialogData.emit, dialogData.payload)">
                        <span v-t="$t(`message.action_device_management_${dialogData.action}`).replace(/[\[\]\s]/g, '')">
                        </span>
                    </el-button>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
    props: ['dialogData'],
    data() {
        return {};
    },
    methods: {}
}
</script>

<style scoped></style>
